<template>
    <vertical-form-table
        v-model="form"
        v-bind="{
            items,
        }"
        @input="emit"
    />
</template>

<script>
import { initExpoMatching } from "@/assets/variables/inits";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import { attrs_input } from "@/assets/variables";

const items = [
    {
        ...attrs_input,

        key: "refuseMsg",
        term: "거부사유",
        type: "textarea",
        required: true,
    },
];

export default {
    components: {
        VerticalFormTable,
    },
    props: {
        value: { type: Object, default: initExpoMatching }, // form
    },
    data: () => ({
        form: initExpoMatching(),
        items,
    }),
    methods: {
        sync() {
            this.form = initExpoMatching(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style>
</style>